import { Layout } from 'antd';
import React from 'react';

import { useLayoutMenuContext } from '../../context/LayoutMenuContext';
import { SideBarHeader } from './Header';
import { SideBarMenu } from './Menu';
import './styles.css';
import { SideBarUserProfile } from './UserProfile';

const { Sider } = Layout;

export const SideBar: React.FC = () => {
  const { isMobile, onCollapse, collapsed } = useLayoutMenuContext();

  return (
    <Sider
      className="side-menu"
      width={272}
      collapsedWidth={isMobile ? 0 : 70}
      trigger={null}
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
    >
      <SideBarHeader />
      <SideBarUserProfile collapsed={collapsed} />
      <SideBarMenu />
    </Sider>
  );
};
